import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateSexualHealthCompletion(
  patient: Patient | null | undefined,
) {
  const sexualHealth = patient?.obGynHistory?.sexualHealth;
  const maleSh = patient?.maleHistory?.sexualHealth;
  const isMale = patient?.gender === "AMAB";

  const hasPapSmear =
    sexualHealth?.hadPapSmear !== undefined &&
    sexualHealth?.hadPapSmear !== null &&
    (sexualHealth.hadPapSmear !== true ||
      (sexualHealth.papSmearResultAbnormal !== undefined &&
        sexualHealth.papSmearResultAbnormal !== null));

  const hasSTDs =
    sexualHealth?.hadSTDs !== undefined && sexualHealth?.hadSTDs !== null;

  const hasVaginalInfections =
    sexualHealth?.hasVaginalInfectionHistory !== undefined &&
    sexualHealth?.hasVaginalInfectionHistory !== null;

  const hasPainfulIntercourse =
    sexualHealth?.hasPainfulIntercourse !== undefined &&
    sexualHealth?.hasPainfulIntercourse !== null;

  const hasLubricants =
    sexualHealth?.usesLubricant !== undefined &&
    sexualHealth?.usesLubricant !== null;

  const hasPartnerEjaculate =
    sexualHealth?.isPartnerEjaculatingInVagina !== undefined &&
    sexualHealth?.isPartnerEjaculatingInVagina !== null;

  const hasErectileDifficulties =
    maleSh?.hasDifficultiesWithErection !== undefined &&
    maleSh?.hasDifficultiesWithErection !== null;

  const fields = isMale
    ? [hasSTDs, hasPainfulIntercourse, hasLubricants, hasErectileDifficulties]
    : [
        hasPapSmear,
        hasSTDs,
        hasVaginalInfections,
        hasPainfulIntercourse,
        hasLubricants,
        hasPartnerEjaculate,
      ];

  const completed = fields.filter(Boolean).length;
  const total = fields.length;

  return {
    percent: total > 0 ? completed / total : 0,
    label: `${completed}/${total} answered`,
    completed,
    total,
  };
}
